import Passwordless from 'supertokens-auth-react/recipe/passwordless';
import Session from 'supertokens-auth-react/recipe/session';

export function getApiDomain() {
  return process.env.REACT_APP_API_DOMAIN || 'http://localhost:54320';
}

export function getWebsiteDomain() {
  return process.env.REACT_APP_WEBSITE_DOMAIN || 'http://localhost:54321';
}

export function getApiBasePath() {
  return process.env.REACT_APP_API_BASE_PATH || '/';
}

export function getWebsiteBasePath() {
  return process.env.REACT_APP_WEBSITE_BASE_PATH || '/';
}

export function getCookieDomain() {
  return process.env.REACT_APP_COOKIE_DOMAIN || 'localhost';
}

export const SuperTokensConfig = {
  appInfo: {
    appName: 'Credit Key Login',
    apiDomain: getApiDomain(),
    apiBasePath: getApiBasePath(),
    websiteDomain: getWebsiteDomain(),
    websiteBasePath: getWebsiteBasePath(),
  },
  recipeList: [
    Session.init({
      sessionTokenBackendDomain: getCookieDomain(),
      sessionTokenFrontendDomain: getCookieDomain(),
    }),
    Passwordless.init({
      contactMethod: 'EMAIL_OR_PHONE',
    }),
  ],
};
